import styled from 'styled-components';
import { List } from 'antd';

// eslint-disable-next-line import/prefer-default-export
export const Meta = styled(List.Item.Meta)`
  .ant-list-item-meta-avatar {
    width: 25%;
  }
`;
